'use strict';

var whichTypedArray = require('which-typed-array');

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};



//////////////////
// WEBPACK FOOTER
// ./~/is-typed-array/index.js
// module id = 1334
// module chunks = 12